<template>
		<v-layout row justify-center>
			<v-flex>
				<v-card-text class="py-0">
					<v-flex>
						<v-autocomplete
							dense
							:items="legacyContract.items"
							item-value="id"
							item-text="name"
							v-model="legacyContract.selected"
							label="Contrat"
							return-object>
						</v-autocomplete>
					</v-flex>

					<v-flex>
						<v-autocomplete
							dense
							:items="source_types"
							v-model="legacy_asset_selected"
							label="Type d'asset">
						</v-autocomplete>
					</v-flex>

					<v-flex>
						<v-text-field
							dense
							label="Précision"
							v-model="precision"
							hint="Une précision sur l'asset.">
						</v-text-field>
					</v-flex>

					<v-flex>
						<v-select
							dense
							:items="qc_levels"
							v-model="qc_type_selected"
							label="Type de QC">
						</v-select>
					</v-flex>

				</v-card-text>
				<v-card-actions class="background">
					<v-spacer></v-spacer>
					<v-btn
						class="mr-0 background--text"
						:disabled="disableSubmitButton"
						@click="submit(); $emit('close')"
						color="primary"
						:loading="submitLoading">
						Envoyer
					</v-btn>
				</v-card-actions>
			</v-flex>
		</v-layout>

</template>

<script>
import { mapGetters } from 'vuex'

export default {
	props: [ 'details', 'wf_data' ],
	data () {
		return {
			localJob: {},
			manifest: null,
			errors: [],
			submitLoading: false,
			legacyContract: {
				items: [],
				selected: ''
			},
			legacy_asset_selected: '',
			selectedAsset: {},
			precision: '',
			qc_type_selected: ''
		}
	},

	computed: {
		...mapGetters([
			'user'
		]),

		disableSubmitButton () {
			let disabled = (
				!this.legacyContract.selected ||
				!this.legacy_asset_selected ||
				!this.qc_type_selected
			)
			return disabled
		},
		source_types () {
			if (this.wf_data) {
				let param = this.wf_data.parameters.find(param => {
					return param.name === 'source_type'
				})
				if (param) return param.choices
			}
			return []
		},
		qc_levels () {
			if (this.wf_data) {
				let param = this.wf_data.parameters.find(param => {
					return param.name === 'qc_level'
				})
				if (param) return param.choices
			}
			return []
		}
	},

	methods: {

		getLegacyContracts () {
			this.$apiPublic.get_legacy_contracts()
				.then(results => {
					this.legacyContract.items = results
					if (this.details.hasOwnProperty('legacy_contract_id')) {
						for (let i = 0; i < results.length; i++) {
							const contract = results[i]
							if (contract.id === this.details['legacy_contract_id']) {
								this.legacyContract.selected = contract
								break
							}
						}
					}
				})
				.catch(error => {
					console.log(error)
				})
		},

		submit () {
			this.submitLoading = true
			let data = {
				jd_id: window.appConfig.maestro_wf['asset legacy ingest'].id,
				parameters: {
					'legacy_contract_id': this.legacyContract.selected.id,
					'source_type': this.legacy_asset_selected,
					'precision': this.precision,
					'qc_level': this.qc_type_selected
				}
			}
			this.$emit('submit')
			this.$ApiMaestro.jobrequest_create(data)
				.then(response => {
					this.submitLoading = false
					this.$emit('maestroFormSent', response)
				})
				.catch(error => {
					console.error(error)
					this.submitLoading = false
					this.localJob = {}
					this.$emit('maestroFormErrorSending', error.response)
				})
		}
	},

	mounted () {
		this.getLegacyContracts()
		for (const param of this.wf_data.parameters) {
			if (param.name === 'qc_level' && param.default) {
				this.qc_type_selected = param.default
				break
			}
		}
		if (this.details.hasOwnProperty('precision')) {
			this.precision = this.details['precision']
		}
		if (this.details.hasOwnProperty('qc_level')) {
			for (let i = 0; i < this.qc_levels.length; i++) {
				const qcType = this.qc_levels[i]
				if (qcType === this.details['qc_level']) {
					this.qc_type_selected = this.details['qc_level']
					break
				}
			}
		}
		if (this.details.hasOwnProperty('source_type')) {
			for (let i = 0; i < this.source_types.length; i++) {
				const item = this.source_types[i]
				if (item.value === this.details['source_type']) {
					this.legacy_asset_selected = this.details['source_type']
					break
				}
			}
		}
	}
}
</script>



// WEBPACK FOOTER //
// src/pages/maestro/jobs/launcher/job_launcher_form_legacy.vue